import {Link} from 'react-router-dom'
import Navbar from '../../components/Navbar'
import MainSectionContact from './MainSectionContact';
import ContactBoxes from './ContactBoxes';
import ContactForm from './ContactForm';
import Map from './Map';
import { Helmet } from "react-helmet-async";
import './Contact.css';
import Footer from '../../components/Footer'
import DragupButton from '../../components/DragupButton';
function Contact() {
    return (
      <>
      <Helmet>
        <title>Kontakt | Elektro Thome</title>
        <link rel="canonical" href="https://energy-thome.com/contact" />
      </Helmet>
      <DragupButton></DragupButton>
      <Navbar></Navbar>
      <MainSectionContact />
      <ContactBoxes />
      <div className="contact-container">
        <ContactForm />
        <Map />
      </div>
      <Footer></Footer>
    </>
    );
  }
export default Contact
